<template>
  <div class="pie-chart-container container" :id="`pie-chart-container-${chartId}`">
    <h2>{{ chartData.title }}</h2>
    <div class="keys">
      <div
        v-for="(key, index) in chartData.data"
        :style="`width: calc(${100 / chartData.data.length}% - ${(chartData.data.length - 1) * 5}px); background-color: ${colors[index]}`"
        :key="`key-${chartId}-${index}`"
        class="key"
      >
        <span>{{ `${key.name}: ${key.value}` }}</span>
      </div>
    </div>
    <svg height="500" :id="`pie-chart-${chartId}`"></svg>
  </div>
</template>

<script>
import * as d3 from 'd3'
import axios from 'axios'
export default {
  props: {
    dataUrl: {
      type: String,
      default: ''
    },
    chartId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      chartData: {},
      colors: [
        '#c5dffc',
        '#92c5f5',
        '#5ba6eb',
        '#2885dd',
        '#0d69c9',
        '#044bad',
        '#032e8e',
        '#041774'
      ]
    }
  },
  mounted () {
    this.getChartData()

    window.addEventListener('resize', () => {
      this.generateChart()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.generateChart()
    })
  },
  methods: {
    /**
     * Used to retrieve chart data from URL
     */
    getChartData () {
      axios.get(this.dataUrl).then((response) => {
        console.log('Response: ', response)
        // Format received data
        this.chartData = response.data
        console.log('Chart data: ', this.chartData)
        this.generateChart()
      }).catch((err) => {
        console.log(err)
      })
    },
    /**
     * Generate chart with d3
     */
    generateChart () {
      const graphicElement = document.getElementById(`pie-chart-container-${this.chartId}`)
      const styles = window.getComputedStyle(graphicElement)
      const graphicPadding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight)
      const diameter = (graphicElement.clientWidth - graphicPadding) * 0.75

      d3.select(`#pie-chart-${this.chartId}`).html('')

      const svg = d3.select(`#pie-chart-${this.chartId}`)
        .attr('width', diameter)
        .attr('height', diameter)
        .attr('class', 'bubble')

      const g = svg.append('g').attr('transform', `translate(${diameter / 2},${diameter / 2})`)

      // let fontSize = 12
      // if (diameter < 540) {
      //   fontSize = 10
      // }

      const pie = d3.pie().value(d => d.value)
      const color = d3.scaleOrdinal(this.colors)
      const arc = d3.arc()
        .innerRadius(0)
        .outerRadius(diameter / 2)

      const arcs = g.selectAll('arc')
        .data(pie(this.chartData.data))
        .enter()
        .append('g')
        .attr('class', 'arc')

      arcs.append('path')
        .attr('fill', (d, i) => {
          return color(i)
        })
        .attr('d', arc)
      
      // node.append('text')
      //   .attr('dy', '0em')
      //   .style('text-anchor', 'middle')
      //   .text((d) => {
      //     return d.data.name
      //   })
      //   .attr('font-size', `${fontSize}px`)
      
      // node.append('text')
      //   .attr('dy', '1em')
      //   .style('text-anchor', 'middle')
      //   .text((d) => {
      //     return d.data.value + 'B'
      //   })
      //   .attr('font-size', `${fontSize}px`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';
svg {
  display: block;
  margin: 0 auto;
}
</style>
